import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';

// Shared chrome for the legal/policy pages so T&C, Privacy and Refund stay
// visually consistent. Pass the page title, meta description, canonical path,
// a last-updated date, and the body as children (use <h2>/<p>/<ul> etc.).
const LegalLayout = ({ title, description, path, updated, children }) => (
  <div className="min-h-screen pt-20">
    <Helmet>
      <title>{`${title} | Rudragarh Resort`}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={`${title} | Rudragarh Resort`} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={`https://www.rudragarh.com${path}`} />
      <link rel="canonical" href={`https://www.rudragarh.com${path}`} />
    </Helmet>

    <section className="section-padding container-padding">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-3xl mx-auto"
      >
        <p className="overline text-gold-500 mb-3">Legal</p>
        <h1 className="text-3xl md:text-4xl font-heading mb-2">{title}</h1>
        {updated && (
          <p className="text-sm text-foreground/50 mb-10">Last updated: {updated}</p>
        )}
        <div className="legal-body space-y-5 text-foreground/70 leading-relaxed">
          {children}
        </div>
      </motion.div>
    </section>
  </div>
);

export default LegalLayout;
